import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute } from 'react-router'
import registerServiceWorker from './registerServiceWorker';

import 'bootstrap/dist/css/bootstrap.css';
import './css/bootstrap-rtl.css';
import './css/index.css';
import './api/prototype'

// Import Component
import App from './component/app.jsx';
import login from './component/login.jsx';
import logout from './component/logout.jsx';
import home from './component/home.jsx';
import Projectpage from './component/projectpage.jsx';
import Timerpage from './component/timerpage.jsx';
import Reportpage from './component/reportpage.jsx';
import Workspacepage from './component/workspacepage.jsx';
import Userpage from './component/userpage.jsx';

//Import Redux
import { Provider } from 'react-redux';
import store, { history } from './store.js';

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <Route path="/" component={home}>
                <Route path="app" component={App}>
                    <IndexRoute component={Timerpage} />
                    <Route path="project" component={Projectpage} />
                    <Route path="report" component={Reportpage} />
                    <Route path="workspace" component={Workspacepage} />
                    <Route path="user" component={Userpage} />
                </Route>
                <Route path="login" component={login} />
                <Route path="logout" component={logout} />
            </Route>
        </Router>
    </Provider>
, document.getElementById('root'));
registerServiceWorker();
